import styled from 'styled-components';
import { ButtonGroup } from '@material-ui/core';
import Button from '@material-ui/core/Button';
export const StyledButtonGroup = styled(ButtonGroup)`
  display: flex;
  justify-content: flex-end;
`;
export const StyledButtonRun = styled(Button)`
  &.MuiButton-root {
    margin: 0px 12px;
    border-radius: 10px;
    min-width: 64px !important;
    height: 32px !important;
    background: #1661a6;
    border: none !important;
    border-radius: 4px !important;
    line-height: 15px !important;
    font-size: 13px !important;
    color: white !important;
    text-transform: none !important;
  }

  &.Mui-disabled {
    opacity: 0.65;
  }

  &:hover {
    background: #1f84e1 !important;
  }
`;
export const StyledButtonSave = styled(Button)`
  &.MuiButton-root {
    margin-right: 32px;
    border-radius: 10px;
    min-width: 92px !important;
    height: 32px !important;
    background: #393939;
    border: none !important;
    border-radius: 4px !important;
    line-height: 15px !important;
    font-size: 13px !important;
    color: white !important;
    text-transform: none !important;
  }

  &.Mui-disabled {
    opacity: 0.65;
  }

  &:hover {
    color: #393939;
  }
`;
export const StyledSpan = styled.span`
  && {
    font-size: 20px;
    cursor: pointer;
  }
`;